// type:R-读W-写
export const registerType = [{
    modelValue: '',
    label: '单体电池电压',
    value: '00',
    type: ['R']
  },
  {
    modelValue: '',
    label: '电池温度',
    value: '20',
    type: ['R']
  },
  {
    modelValue: '',
    label: '电池总电压',
    value: '28',
    type: ['R']
  },
  {
    modelValue: '',
    label: '电流数据',
    value: '29',
    type: ['R']
  },
  {
    modelValue: '',
    label: 'SOC',
    value: '2A',
    type: ['R']
  },
  {
    modelValue: '',
    label: '最高单体电压',
    value: '2B',
    type: ['R']
  },
  {
    modelValue: '',
    label: '最低单体电压',
    value: '2C',
    type: ['R']
  },
  {
    modelValue: '',
    label: '最高单体温度',
    value: '2D',
    type: ['R']
  },
  {
    modelValue: '',
    label: '最低单体温度',
    value: '2E',
    type: ['R']
  },
  {
    modelValue: '',
    label: '充放电状态',
    value: '2F',
    type: ['R']
  },
  {
    modelValue: '',
    label: '电池剩余容量',
    value: '30',
    type: ['R']
  },
  {
    modelValue: '',
    label: '电池数量',
    value: '31',
    type: ['R']
  },
  {
    modelValue: '',
    label: '电池温度传感器数量',
    value: '32',
    type: ['R']
  },
  {
    modelValue: '',
    label: '电池使用循环次数',
    value: '33',
    type: ['R']
  },
  {
    modelValue: '',
    label: '均衡状态',
    value: '34',
    type: ['R']
  },
  {
    modelValue: '',
    label: '充电MOS状态',
    value: '35',
    type: ['R']
  },
  {
    modelValue: '',
    label: '放电MOS状态',
    value: '36',
    type: ['R']
  },
  {
    modelValue: '',
    label: '平均电压',
    value: '37',
    type: ['R']
  },
  {
    modelValue: '',
    label: '压差',
    value: '38',
    type: ['R']
  },
  {
    modelValue: '',
    label: '功率',
    value: '39',
    type: ['R']
  },
  {
    modelValue: '',
    label: '故障状态1',
    value: '3A',
    type: ['R']
  },
  {
    modelValue: '',
    label: '故障状态2',
    value: '3B',
    type: ['R']
  },
  {
    modelValue: '',
    label: '故障状态3',
    value: '3C',
    type: ['R']
  },
  {
    modelValue: '',
    label: '故障状态4',
    value: '3D',
    type: ['R']
  },
  {
    modelValue: '',
    label: '剩余里程',
    value: '3E',
    type: ['R']
  },
  {
    modelValue: '',
    label: '主动均衡状态',
    value: '3F',
    type: ['R']
  },
  {
    modelValue: '',
    label: '均衡电流',
    value: '40',
    type: ['R']
  },
  {
    modelValue: '',
    label: '均衡位置',
    value: '41',
    type: ['R']
  },
  {
    modelValue: '',
    label: 'MOS温度',
    value: '42',
    type: ['R']
  },
  {
    modelValue: '',
    label: '预留信号5',
    value: '43',
    type: ['R']
  },
  {
    modelValue: '',
    label: '预留信号6',
    value: '44',
    type: ['R']
  },
  {
    modelValue: '',
    label: '预留信号7',
    value: '45',
    type: ['R']
  },
  {
    modelValue: '',
    label: '预留信号8',
    value: '46',
    type: ['R']
  },
  {
    modelValue: '',
    label: '单体电池电压',
    value: '47484950515253545556',
    type: ['R']
  },
  {
    modelValue: '',
    label: 'SN码',
    value: '5758595A5B5C5D5E5F606162',
    type: ['R']
  },
  {
    modelValue: '',
    label: '防盗状态',
    value: '63',
    type: ['R']
  },
  {
    modelValue: '',
    label: '加热状态',
    value: '64',
    type: ['R']
  },
  {
    modelValue: '',
    label: '最近一次充电时间',
    value: '656667',
    type: ['R']
  },
  {
    modelValue: '',
    label: '最近一次放电时间',
    value: '68696A',
    type: ['R']
  },
  {
    modelValue: '',
    label: '预留',
    value: '6B',
    type: ['R']
  },
  {
    modelValue: '',
    label: '额定容量',
    value: '80',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '单体基准电压',
    value: '81',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '采集板个数',
    value: '82',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '采集板1单体个数',
    value: '83',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '采集板2单体个数',
    value: '84',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '采集板3单体个数',
    value: '85',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '采集板1温度个数',
    value: '86',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '采集板2温度个数',
    value: '87',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '采集板3温度个数',
    value: '88',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '电池类型',
    value: '89',
    type: ['R', 'W'],
    max: 65535,
    min: 0,
    contentType: 'select',
    options: [{
        modelValue: '',
        label: '磷酸铁锂',
        value: 0
      },
      {
        modelValue: '',
        label: '三元',
        value: 1
      },
      {
        modelValue: '',
        label: '钛酸锂',
        value: 2
      },
    ]
  },
  {
    modelValue: '',
    label: '休眠等待时间',
    value: '8A',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '单体电压过高一级告警',
    value: '8B',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '单体电压过高二级告警',
    value: '8C',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '单体电压过低一级告警',
    value: '8D',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '单体电压过低二级告警',
    value: '8E',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '总压过高一级告警',
    value: '8F',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '总压过高二级告警',
    value: '90',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '总压过低一级告警',
    value: '91',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '总压过低二级告警',
    value: '92',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '充电电流过高一级告警',
    value: '93',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '充电电流过高二级告警',
    value: '94',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '放电电流过高一级告警',
    value: '95',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '放电电流过高二级告警',
    value: '96',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '充电温度过高一级告警',
    value: '97',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '充电温度过高二级告警',
    value: '98',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '充电温度过低一级告警',
    value: '99',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '充电温度过低二级告警',
    value: '9A',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '放电温度过高一级告警',
    value: '9B',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '放电温度过高二级告警',
    value: '9C',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '放电温度过低一级告警',
    value: '9D',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '放电温度过低二级告警',
    value: '9E',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '压差过大一级告警值',
    value: '9F',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '压差过大二级告警值',
    value: 'A0',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '温差过大一级告警值',
    value: 'A1',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '温差过大二级告警值',
    value: 'A2',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '均衡开启电压',
    value: 'A3',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '均衡开启压差',
    value: 'A4',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '充电MOS管开关控制',
    value: 'A5',
    type: ['R', 'W'],
    max: 65535,
    min: 0,
    contentType: 'select',
    options: [{
        modelValue: '',
        label: '关',
        value: 0
      },
      {
        modelValue: '',
        label: '开',
        value: 1
      },
    ]
  },
  {
    modelValue: '',
    label: '放电MOS管开关控制',
    value: 'A6',
    type: ['R', 'W'],
    max: 65535,
    min: 0,
    contentType: 'select',
    options: [{
        modelValue: '',
        label: '关',
        value: 0
      },
      {
        modelValue: '',
        label: '开',
        value: 1
      },
    ]
  },
  {
    modelValue: '',
    label: 'SOC设置',
    value: 'A7',
    type: ['W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '功率管温度保护告警',
    value: 'A8',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '软件版本号',
    value: 'A9',
    type: ['R'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '硬件版本号',
    value: 'B1',
    type: ['R'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '机器编码',
    value: 'B9',
    type: ['R'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '参数设置密码',
    value: 'C9CACB',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '生产日期',
    value: 'CC',
    type: ['R'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '电池串数',
    value: 'CE',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '主动均衡开关',
    value: 'CF',
    type: ['R', 'W'],
    max: 65535,
    min: 0,
    contentType: 'select',
    options: [{
        modelValue: '',
        label: '关',
        value: 0
      },
      {
        modelValue: '',
        label: '开',
        value: 1
      },
    ]
  },
  {
    modelValue: '',
    label: '主动均衡电流',
    value: 'D0',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '通信方式',
    value: 'D1',
    type: ['R', 'W'],
    max: 65535,
    min: 0,
    contentType: 'select',
    options: [{
        modelValue: '',
        label: 'RS485',
        value: 0
      },
      {
        modelValue: '',
        label: 'CAN',
        value: 1
      },
    ]
  },

  {
    modelValue: '',
    label: '逆变器制造商',
    value: 'D2',
    type: ['R', 'W'],
    max: 65535,
    min: 0,
    contentType: 'select',
    options: [{
        modelValue: '',
        label: 'NONE',
        value: 0
      },
      {
        modelValue: '',
        label: 'PYLON',
        value: 1
      },
      {
        modelValue: '',
        label: 'GROWAT',
        value: 2
      },
      {
        modelValue: '',
        label: 'SOFAR',
        value: 3
      },
      {
        modelValue: '',
        label: 'VOLTRONICPOWER',
        value: 4
      },
      {
        modelValue: '',
        label: 'GOODWE',
        value: 5
      },
      {
        modelValue: '',
        label: 'SRNE',
        value: 6
      },
      {
        modelValue: '',
        label: 'MUST',
        value: 7
      },
      {
        modelValue: '',
        label: 'VICTRONENERGY',
        value: 8
      },
      {
        modelValue: '',
        label: 'SMA',
        value: 9
      },
      {
        modelValue: '',
        label: 'DEYE',
        value: 10
      },
      {
        modelValue: '',
        label: 'AISWEI',
        value: 11
      },
      {
        modelValue: '',
        label: 'SACOLAR',
        value: 12
      },
      {
        modelValue: '',
        label: 'SOLARK',
        value: 13
      },
      {
        modelValue: '',
        label: 'XMT',
        value: 14
      },
      {
        modelValue: '',
        label: 'SOLIS',
        value: 15
      },
      {
        modelValue: '',
        label: 'LUXPOWERTEK',
        value: 16
      },
      {
        modelValue: '',
        label: 'STUDER',
        value: 17
      },
      {
        modelValue: '',
        label: 'SOROTEC',
        value: 18
      },
    ]
  },
  {
    modelValue: '',
    label: 'RTC',
    value: 'D4D5D6',
    type: ['R', 'W'],
    max: 65535,
    min: 0,
    contentType: 'date'
  },
  {
    modelValue: '',
    label: '强制启动开关',
    value: 'D7',
    type: ['R', 'W'],
    max: 65535,
    min: 0,
    disabled: true
  },
  {
    modelValue: '',
    label: '加热开关',
    value: 'D8',
    type: ['R', 'W'],
    max: 65535,
    min: 0,
    contentType: 'select',
    options: [{
        modelValue: '',
        label: '加热关闭',
        value: 0
      },
      {
        modelValue: '',
        label: '加热开启',
        value: 1
      },
    ]
  },
  {
    modelValue: '',
    label: 'SOC过高告警值',
    value: 'D9',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: 'SOC过高告警恢复值',
    value: 'DA',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: 'SOC过低告警值',
    value: 'DB',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: 'SOC过低告警恢复值',
    value: 'DC',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '灯光告警或蜂鸣器告警',
    value: 'DD',
    type: ['R', 'W'],
    max: 65535,
    min: 0,
    contentType: 'select',
    options: [{
        modelValue: '',
        label: '无报警',
        value: 0
      },
      {
        modelValue: '',
        label: '灯光报警',
        value: 1
      },
      {
        modelValue: '',
        label: '蜂鸣器报警',
        value: 2
      },
    ]
  },
  {
    modelValue: '',
    label: '电压校准',
    value: 'DE',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: 'X三轴加速度',
    value: 'DF',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: 'Y三轴加速度',
    value: 'E0',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: 'Z三轴加速度',
    value: 'E1',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '解锁状态控制',
    value: 'E2',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '均衡截止电压',
    value: 'E3',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '加热开启温度',
    value: 'E4',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '钥匙逻辑',
    value: 'E5',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '均衡宝-印规版本启用开关',
    value: 'E6',
    type: ['R', 'W'],
    max: 1,
    min: 0,
    contentType: 'select',
    options: [{
        modelValue: '',
        label: '禁用',
        value: 0
      },
      {
        modelValue: '',
        label: '启用',
        value: 1
      },
    ]
  },
  {
    modelValue: '',
    label: '预留',
    value: 'E7',
    type: ['R', 'W'],
    max: 65535,
    min: 0
  },
  {
    modelValue: '',
    label: '系统重启',
    value: 'F0',
    type: ['W'],
    max: 65535,
    min: 0,
    disabledData: true
  },
  {
    modelValue: '',
    label: '关闭系统',
    value: 'F1',
    type: ['W'],
    max: 65535,
    min: 0,
    disabledData: true
  },
  {
    modelValue: '',
    label: '电流归零',
    value: 'F2',
    type: ['W'],
    max: 65535,
    min: 0,
    disabledData: true
  },
  {
    modelValue: '',
    label: '恢复出厂设置',
    value: 'F3',
    type: ['W'],
    max: 65535,
    min: 0,
    disabledData: true
  },
  // { modelValue:'', label:'当前历史故障序号', value:'100', type:['R'], max:65535, min:0 },
  // { modelValue:'', label:'历史故障总条数', value:'101', type:['R'], max:65535, min:0 },
  // { modelValue:'', label:'单个历史故障信息长度N', value:'102', type:['R'], max:65535, min:0 },
  {
    modelValue: '',
    label: '历史故障信息',
    value: '100',
    type: ['R'],
    max: 65535,
    min: 0
  },
]

// 故障信息详情
export const historicalFailure = [{
    "label": "当前历史故障序号",
    "key": "currentHistoricalFaultSequenceNo",
    "type": "Integer",
    "children": null
  },
  {
    "label": "历史故障信息详情",
    "key": "historicalFaultDetail",
    "type": "object",
    "children": [{
        "label": "记录ID",
        "key": "idExplain"
      },
      {
        "label": "记录时间",
        "key": "recordTime"
      },
      // {
      //     "label": "记录时间之月",
      //     "key": "month"
      // },
      // {
      //     "label": "记录时间之日",
      //     "key": "day"
      // },
      // {
      //     "label": "记录时间之时",
      //     "key": "hour"
      // },
      // {
      //     "label": "记录时间之分",
      //     "key": "minute"
      // },
      // {
      //     "label": "记录时间之秒",
      //     "key": "second"
      // },
      {
        "label": "产生或消失",
        "key": "generateOrDisappearName"
      },
      {
        "label": "电池包总电压(V)",
        "key": "totalVoltageBatteryPack"
      },
      {
        "label": "电池输出电流(A)",
        "key": "batteryOutputCurrent"
      },
      {
        "label": "SOC",
        "key": "soc"
      },
      {
        "label": "MOS状态",
        "key": "mosStateName"
      },
      {
        "label": "最高单体电压(mV)",
        "key": "maximumIndividualVoltage"
      },
      {
        "label": "最高单体电压号",
        "key": "maximumIndividualVoltageNo"
      },
      {
        "label": "最低单体电压(mV)",
        "key": "minimumIndividualVoltage"
      },
      {
        "label": "最低单体电压号",
        "key": "minimumIndividualVoltageNo"
      },
      {
        "label": "单体最高温度(°C)",
        "key": "maxTemperatureIndividualUnit"
      },
      {
        "label": "单体最高温度号",
        "key": "maxTemperatureIndividualUnitNo"
      },
      {
        "label": "单体最低温度(°C)",
        "key": "minTemperatureIndividualUnit"
      },
      {
        "label": "单体最低温度号",
        "key": "minTemperatureIndividualUnitNo"
      },
      {
        "label": "故障码",
        "key": "faultCode"
      },
      {
        "label": "crc",
        "key": "crc"
      }
    ]
  }
]

// 保护板数据
export const protectiveBoardData = [{
    "label": "单体电池电压集合",
    "key": "list",
    "type": "array",
    "children": [{
        "label": "地址",
        "key": "address"
      },
      {
        "label": "电压",
        "key": "cellVoltage"
      }
    ]
  },
  {
    "label": "电池温度集合",
    "key": "temperatures",
    "type": "array",
    "children": [{
        "label": "地址",
        "key": "address"
      },
      {
        "label": "电池温度",
        "key": "temperature"
      }
    ]
  },
  {
    "label": "电池总电压",
    "key": "totalBatteryVoltage",
    "type": "Double",
    "children": null
  },
  {
    "label": "电流数据",
    "key": "currentData",
    "type": "Double",
    "children": null
  },
  {
    "label": "soc",
    "key": "soc",
    "type": "Double",
    "children": null
  },
  {
    "label": "最高单体电压",
    "key": "maxSingleCellVoltage",
    "type": "Integer",
    "children": null
  },
  {
    "label": "最低单体电压",
    "key": "minSingleCellVoltage",
    "type": "Integer",
    "children": null
  },
  {
    "label": "最高单体温度",
    "key": "maxBatteryTemperature",
    "type": "Integer",
    "children": null
  },
  {
    "label": "最低单体温度",
    "key": "minBatteryTemperature",
    "type": "Integer",
    "children": null
  },
  {
    "label": "充放电状态",
    "key": "cdStatusName",
    "type": "Integer",
    "children": null
  },
  {
    "label": "电池剩余容量",
    "key": "remainingBatteryCapacity",
    "type": "Double",
    "children": null
  },
  {
    "label": "电池数量",
    "key": "batteryNum",
    "type": "Integer",
    "children": null
  },
  {
    "label": "电池温度传感器数量",
    "key": "cgqNum",
    "type": "Integer",
    "children": null
  },
  {
    "label": "电池使用循环次数",
    "key": "cyclesNum",
    "type": "Integer",
    "children": null
  },
  {
    "label": "均衡状态",
    "key": "equilibriumState",
    "type": "Integer",
    "children": null
  },
  {
    "label": "充电MOS状态",
    "key": "cdMosState",
    "type": "Integer",
    "children": null
  },
  {
    "label": "放电MOS状态",
    "key": "fdMosState",
    "type": "Integer",
    "children": null
  },
  {
    "label": "平均电压",
    "key": "avgVoltage",
    "type": "Integer",
    "children": null
  },
  {
    "label": "压差",
    "key": "differentialPressure",
    "type": "Integer",
    "children": null
  },
  {
    "label": "功率",
    "key": "power",
    "type": "Integer",
    "children": null
  },
  {
    "label": "故障状态1",
    "key": "faultStatusOne",
    "type": "Integer",
    "children": null
  },
  {
    "label": "故障状态1故障集合",
    "key": "daLiFaultOne",
    "type": "object",
    "children": [{
        "label": "单体电压过高一级告警",
        "key": "singleCellVoltageHighOneAlarmStatus"
      },
      {
        "label": "单体电压过高二级告警",
        "key": "singleCellVoltageHighTwoAlarmStatus"
      },
      {
        "label": "单体电压过低一级告警",
        "key": "singleCellVoltageLowOneAlarmStatus"
      },
      {
        "label": "单体电压过低二级告警",
        "key": "singleCellVoltageLowTwoAlarmStatus"
      },
      {
        "label": "总压过高一级告警",
        "key": "totalSingleCellVoltageHighOneAlarmStatus"
      },
      {
        "label": "总压过高二级告警",
        "key": "totalSingleCellVoltageHighTwoAlarmStatus"
      },
      {
        "label": "总压过低一级告警",
        "key": "totalSingleCellVoltageLowOneAlarmStatus"
      },
      {
        "label": "总压过低二级告警",
        "key": "totalSingleCellVoltageLowTwoAlarmStatus"
      },
      {
        "label": "充电温度过高一级告警",
        "key": "cdtemperatureHighOneAlarmStatus"
      },
      {
        "label": "充电温度过高二级告警",
        "key": "cdtemperatureHighTwoAlarmStatus"
      },
      {
        "label": "充电温度过低一级告警",
        "key": "cdtemperatureLowOneAlarmStatus"
      },
      {
        "label": "充电温度过低二级告警",
        "key": "cdtemperatureLowTwoAlarmStatus"
      },
      {
        "label": "放电温度过高一级告警",
        "key": "fdtemperatureHighOneAlarmStatus"
      },
      {
        "label": "放电温度过高二级告警",
        "key": "fdtemperatureHighTwoAlarmStatus"
      },
      {
        "label": "放电温度过低一级告警",
        "key": "fdtemperatureLowOneAlarmStatus"
      },
      {
        "label": "放电温度过低二级告警",
        "key": "fdtemperatureLowTwoAlarmStatus"
      }
    ]
  },
  {
    "label": "故障状态2",
    "key": "faultStatusTwo",
    "type": "Integer",
    "children": null
  },
  {
    "label": "故障状态2故障集合",
    "key": "daLiFaultTwo",
    "type": "object",
    "children": [{
        "label": "充电过流一级告警",
        "key": "chargingCurrentHighOneAlarmStatus"
      },
      {
        "label": "充电过流二级告警",
        "key": "chargingCurrentHighTwoAlarmStatus"
      },
      {
        "label": "放电过流一级告警",
        "key": "fdCurrentHighOneAlarmStatus"
      },
      {
        "label": "放电过流二级告警",
        "key": "fdCurrentHighTwoAlarmStatus"
      },
      {
        "label": "SOC过高一级告警",
        "key": "socHighOneAlarmStatus"
      },
      {
        "label": "SOC过高二级告警",
        "key": "socHighTwoAlarmStatus"
      },
      {
        "label": "SOC过低一级告警",
        "key": "socLowOneAlarmStatus"
      },
      {
        "label": "SOC过低二级告警",
        "key": "socLowTwoAlarmStatus"
      },
      {
        "label": "压差过大一级告警值",
        "key": "differentialPressureHighOneAlarmStatus"
      },
      {
        "label": "压差过大二级告警值",
        "key": "differentialPressureHighTwoAlarmStatus"
      },
      {
        "label": "温差过大一级告警值",
        "key": "differentialTemperatureHighOneAlarmStatus"
      },
      {
        "label": "温差过大二级告警值",
        "key": "differentialTemperatureHighTwoAlarmStatus"
      }
    ]
  },
  {
    "label": "故障状态3",
    "key": "faultStatusThree",
    "type": "Integer",
    "children": null
  },
  {
    "label": "故障状态3故障集合",
    "key": "daLiFaultThree",
    "type": "object",
    "children": [{
        "label": "充电MOS过温警告",
        "key": "cdMosHighTemperatureStatus"
      },
      {
        "label": "放电MOS过温警告",
        "key": "fdMosHighTemperatureStatus"
      },
      {
        "label": "充电MOS温度检测传感器故障",
        "key": "cdMosSensorMalfunctionStatus"
      },
      {
        "label": "放电MOS温度检测传感器故障",
        "key": "fdMosSensorMalfunctionStatus"
      },
      {
        "label": "充电MOS粘连故障",
        "key": "cdMosAdhesiveMalfunctionStatus"
      },
      {
        "label": "放电MOS粘连故障",
        "key": "fdMosAdhesiveMalfunctionStatus"
      },
      {
        "label": "充电MOS断路故障",
        "key": "cdMosOpenCircuitFaultStatus"
      },
      {
        "label": "放电MOS断路故障",
        "key": "fdMosOpenCircuitFaultStatus"
      },
      {
        "label": "AFE采集芯片故障",
        "key": "afeFaultStatus"
      },
      {
        "label": "单体采集掉线",
        "key": "singleUnitCollectionDisconnectedStatus"
      },
      {
        "label": "单体温度传感器故障",
        "key": "individualTemperatureSensorMalfunctionStatus"
      },
      {
        "label": "EEPROM存储故障",
        "key": "eepromFaultStatus"
      },
      {
        "label": "RTC时钟故障",
        "key": "rtcFaultStatus"
      },
      {
        "label": "预充失败",
        "key": "preChargingFailedStatus"
      },
      {
        "label": "整车通信故障",
        "key": "vehicleCommunicationMalfunctionStatus"
      },
      {
        "label": "内网通信模块故障",
        "key": "internalNetworkCommunicationModuleMalfunctionStatus"
      }
    ]
  },
  {
    "label": "故障状态4",
    "key": "faultStatusFour",
    "type": "Integer",
    "children": null
  },
  {
    "label": "故障状态4故障集合",
    "key": "daLiFaultFour",
    "type": "object",
    "children": [{
        "label": "电流模块故障",
        "key": "currentModuleMalfunctionStatus"
      },
      {
        "label": "内总压检测模块故障",
        "key": "internalTotalPressureFaultStatus"
      },
      {
        "label": "短路保护故障",
        "key": "shortCircuitProtectionFaultStatus"
      },
      {
        "label": "低压禁止充电故障",
        "key": "lowVoltageProhibitedChargingFaultStatus"
      }
    ]
  },
  {
    "label": "剩余里程",
    "key": "remainingMileage",
    "type": "Double",
    "children": null
  },
  {
    "label": "主动均衡状态",
    "key": "activeEquilibriumState",
    "type": "Integer",
    "children": null
  },
  {
    "label": "均衡电流",
    "key": "equalizingCurrent",
    "type": "Double",
    "children": null
  },
  {
    "label": "均衡位置",
    "key": "balancedPosition",
    "type": "Integer",
    "children": null
  },
  {
    "label": "MOS温度",
    "key": "mosTemperature",
    "type": "Integer",
    "children": null
  },
  {
    "label": "预留5",
    "key": "reserve_5",
    "type": "Integer",
    "children": null
  },
  {
    "label": "预留6",
    "key": "reserve_6",
    "type": "Integer",
    "children": null
  },
  {
    "label": "预留7",
    "key": "reserve_7",
    "type": "Integer",
    "children": null
  },
  {
    "label": "预留8",
    "key": "reserve_8",
    "type": "Integer",
    "children": null
  },
  {
    "label": "sn",
    "key": "sn",
    "type": "String",
    "children": null
  },
  {
    "label": "防盗状态",
    "key": "antiTheftStatus",
    "type": "Integer",
    "children": null
  },
  {
    "label": "加热状态",
    "key": "heatingState",
    "type": "Integer",
    "children": null
  },
  {
    "label": "最近一次充电时间",
    "key": "lastChargingTime",
    "type": "String",
    "children": null
  },
  {
    "label": "最近一次放电时间",
    "key": "lastDischargeTime",
    "type": "String",
    "children": null
  },
  {
    "label": "额定容量",
    "key": "ratedCapacity",
    "type": "Double",
    "children": null
  },
  {
    "label": "单体基准电压",
    "key": "individualReferenceVoltage",
    "type": "Integer",
    "children": null
  },
  {
    "label": "采集板个数",
    "key": "boardsNum",
    "type": "Integer",
    "children": null
  },
  {
    "label": "采集板1单体个数",
    "key": "boardsNumOne",
    "type": "Integer",
    "children": null
  },
  {
    "label": "采集板2单体个数",
    "key": "boardsNumTwo",
    "type": "Integer",
    "children": null
  },
  {
    "label": "采集板3单体个数",
    "key": "boardsNumThree",
    "type": "Integer",
    "children": null
  },
  {
    "label": "采集板1温度个数",
    "key": "boardsTemperatureNumOne",
    "type": "Integer",
    "children": null
  },
  {
    "label": "采集板2温度个数",
    "key": "boardsTemperatureNumTwo",
    "type": "Integer",
    "children": null
  },
  {
    "label": "采集板3温度个数",
    "key": "boardsTemperatureNumThree",
    "type": "Integer",
    "children": null
  },
  {
    "label": "电池类型",
    "key": "batteryType",
    "type": "Integer",
    "children": null
  },
  {
    "label": "休眠等待时间",
    "key": "waitTime",
    "type": "Integer",
    "children": null
  },
  {
    "label": "单体电压过高一级告警",
    "key": "singleCellVoltageHighOneAlarm",
    "type": "Integer",
    "children": null
  },
  {
    "label": "单体电压过高二级告警",
    "key": "singleCellVoltageHighTwoAlarm",
    "type": "Integer",
    "children": null
  },
  {
    "label": "单体电压过低一级告警",
    "key": "singleCellVoltageLowOneAlarm",
    "type": "Integer",
    "children": null
  },
  {
    "label": "单体电压过低二级告警",
    "key": "singleCellVoltageLowTwoAlarm",
    "type": "Integer",
    "children": null
  },
  {
    "label": "总压过高一级告警",
    "key": "totalSingleCellVoltageHighOneAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "总压过高二级告警",
    "key": "totalSingleCellVoltageHighTwoAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "总压过低一级告警",
    "key": "totalSingleCellVoltageLowOneAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "总压过低二级告警",
    "key": "totalSingleCellVoltageLowTwoAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "充电电流过高一级告警",
    "key": "chargingCurrentHighOneAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "充电电流过高二级告警",
    "key": "chargingCurrentHighTwoAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "放电电流过高一级告警",
    "key": "fdCurrentHighOneAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "放电电流过高二级告警",
    "key": "fdCurrentHighTwoAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "充电温度过高一级告警",
    "key": "cdtemperatureHighOneAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "充电温度过高二级告警",
    "key": "cdtemperatureHighTwoAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "充电温度过低一级告警",
    "key": "cdtemperatureLowOneAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "充电温度过低二级告警",
    "key": "cdtemperatureLowTwoAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "放电温度过高一级告警",
    "key": "fdtemperatureHighOneAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "放电温度过高二级告警",
    "key": "fdtemperatureHighTwoAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "放电温度过低一级告警",
    "key": "fdtemperatureLowOneAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "放电温度过低二级告警",
    "key": "fdtemperatureLowTwoAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "压差过大一级告警值",
    "key": "differentialPressureHighOneAlarm",
    "type": "Integer",
    "children": null
  },
  {
    "label": "压差过大二级告警值",
    "key": "differentialPressureHighTwoAlarm",
    "type": "Integer",
    "children": null
  },
  {
    "label": "温差过大一级告警值",
    "key": "differentialTemperatureHighOneAlarm",
    "type": "Integer",
    "children": null
  },
  {
    "label": "温差过大二级告警值",
    "key": "differentialTemperatureHighTwoAlarm",
    "type": "Integer",
    "children": null
  },
  {
    "label": "均衡开启电压",
    "key": "balancedVoltage",
    "type": "Integer",
    "children": null
  },
  {
    "label": "均衡开启压差",
    "key": "balancedPressure",
    "type": "Integer",
    "children": null
  },
  {
    "label": "充电MOS管开关控制",
    "key": "cdMosControl",
    "type": "Integer",
    "children": null
  },
  {
    "label": "放电MOS管开关控制",
    "key": "fdMosControl",
    "type": "Integer",
    "children": null
  },
  {
    "label": "SOC设置",
    "key": "socSet",
    "type": "Integer",
    "children": null
  },
  {
    "label": "功率管温度保护告警",
    "key": "powerTubeTemperatureprotectionAlarm",
    "type": "Integer",
    "children": null
  },
  {
    "label": "软件版本号",
    "key": "softwareVersion",
    "type": "String",
    "children": null
  },
  {
    "label": "硬件版本号",
    "key": "hardwareVersion",
    "type": "String",
    "children": null
  },
  {
    "label": "机器编码",
    "key": "code",
    "type": "String",
    "children": null
  },
  {
    "label": "系统重启",
    "key": "systemRestart",
    "type": "Integer",
    "children": null
  },
  {
    "label": "关闭系统",
    "key": "systemClose",
    "type": "Integer",
    "children": null
  },
  {
    "label": "电流归零",
    "key": "shutDownSystem",
    "type": "Integer",
    "children": null
  },
  {
    "label": "恢复出厂设置",
    "key": "restoreFactorySettings",
    "type": "Integer",
    "children": null
  },
  {
    "label": "参数设置密码",
    "key": "paramSetPassword",
    "type": "String",
    "children": null
  },
  {
    "label": "生产日期",
    "key": "dateOfManufacture",
    "type": "String",
    "children": null
  },
  {
    "label": "电池串数",
    "key": "batteryStringsNum",
    "type": "Integer",
    "children": null
  },
  {
    "label": "主动均衡开关",
    "key": "activeBalanceSwitch",
    "type": "Integer",
    "children": null
  },
  {
    "label": "主动均衡电流",
    "key": "activeCurrentBalancing",
    "type": "Double",
    "children": null
  },
  {
    "label": "通信方式",
    "key": "communication",
    "type": "Integer",
    "children": null
  },
  {
    "label": "逆变器制造商",
    "key": "inverterManufacturer",
    "type": "Integer",
    "children": null
  },
  {
    "label": "rtc",
    "key": "rtc",
    "type": "String",
    "children": null
  },
  {
    "label": "强制启动开关",
    "key": "forceStartSwitch",
    "type": "Integer",
    "children": null
  },
  {
    "label": "加热开关",
    "key": "heatingSwitch",
    "type": "Integer",
    "children": null
  },
  {
    "label": "SOC过高告警值",
    "key": "socHighAlarmValue",
    "type": "Double",
    "children": null
  },
  {
    "label": "SOC过高告警恢复值",
    "key": "socHighAlarmRecoveryValue",
    "type": "Double",
    "children": null
  },
  {
    "label": "SOC过低告警值",
    "key": "socLowAlarmValue",
    "type": "Double",
    "children": null
  },
  {
    "label": "SOC过低告警恢复值",
    "key": "socLowAlarmRecoveryValue",
    "type": "Double",
    "children": null
  },
  {
    "label": "灯光告警或蜂鸣器告警",
    "key": "lightAlarmOrBuzzerAlarm",
    "type": "Integer",
    "children": null
  },
  {
    "label": "电压校准",
    "key": "voltageCalibration",
    "type": "Double",
    "children": null
  },
  {
    "label": "x轴加速度",
    "key": "xacceleration",
    "type": "Integer",
    "children": null
  },
  {
    "label": "y轴加速度",
    "key": "yacceleration",
    "type": "Integer",
    "children": null
  },
  {
    "label": "z轴加速度",
    "key": "zacceleration",
    "type": "Integer",
    "children": null
  },
  {
    "label": "解锁状态",
    "key": "unlockStateControl",
    "type": "Integer",
    "children": null
  },
  {
    "label": "均衡截止电压",
    "key": "balancedCutOffVoltage",
    "type": "Integer",
    "children": null
  },
  {
    "label": "加热开启温度",
    "key": "heatingActivationTemperature",
    "type": "Integer",
    "children": null
  },
  {
    "label": "钥匙逻辑",
    "key": "keyLogic",
    "type": "Integer",
    "children": null
  },
  {
    "label": "均衡宝印规版本启用开关",
    "key": "balancedTreasure",
    "type": "Integer",
    "children": null
  }
]

// 首页数据显示
export const homeData = [{
    "label": "单体电池电压集合",
    "key": "list",
    "type": "array",
    "children": [{
        "label": "地址",
        "key": "address"
      },
      {
        "label": "电压",
        "key": "cellVoltage"
      }
    ]
  },
  {
    "label": "电池温度集合",
    "key": "temperatures",
    "type": "array",
    "children": [{
        "label": "地址",
        "key": "address"
      },
      {
        "label": "电池温度",
        "key": "temperature"
      }
    ]
  },
  {
    "label": "电池总电压",
    "key": "totalBatteryVoltage",
    "type": "Double",
    "children": null
  },
  {
    "label": "电流数据",
    "key": "currentData",
    "type": "Double",
    "children": null
  },
  {
    "label": "电池数量",
    "key": "batteryNum",
    "type": "Integer",
    "children": null
  },
  {
    "label": "充放电状态",
    "key": "cdStatusName",
    "type": "Integer",
    "children": null
  },
  {
    "label": "最高单体电压",
    "key": "maxSingleCellVoltage",
    "type": "Integer",
    "children": null
  },
  {
    "label": "功率",
    "key": "power",
    "type": "Integer",
    "children": null
  },
  {
    "label": "电池使用循环次数",
    "key": "cyclesNum",
    "type": "Integer",
    "children": null
  },
  {
    "label": "充电MOS状态",
    "key": "cdMosStateName",
    "type": "Integer",
    "children": null
  },
  {
    "label": "最低单体电压",
    "key": "minSingleCellVoltage",
    "type": "Integer",
    "children": null
  },
  {
    "label": "soc",
    "key": "soc",
    "type": "Double",
    "children": null
  },
  {
    "label": "最高单体温度",
    "key": "maxBatteryTemperature",
    "type": "Integer",
    "children": null
  },
  {
    "label": "放电MOS状态",
    "key": "fdMosStateName",
    "type": "Integer",
    "children": null
  },
  {
    "label": "平均电压",
    "key": "avgVoltage",
    "type": "Integer",
    "children": null
  },
  {
    "label": "剩余里程",
    "key": "remainingMileage",
    "type": "Double",
    "children": null
  },
  {
    "label": "最低单体温度",
    "key": "minBatteryTemperature",
    "type": "Integer",
    "children": null
  },
  {
    "label": "均衡状态",
    "key": "equilibriumStateName",
    "type": "Integer",
    "children": null
  },
  {
    "label": "压差",
    "key": "differentialPressure",
    "type": "Integer",
    "children": null
  },
  {
    "label": "电池剩余容量",
    "key": "remainingBatteryCapacity",
    "type": "Double",
    "children": null
  },
  {
    "label": "电池温度传感器数量",
    "key": "cgqNum",
    "type": "Integer",
    "children": null
  },
  {
    "label": "主动均衡状态",
    "key": "activeEquilibriumStateName",
    "type": "Integer",
    "children": null
  },
  {
    "label": "故障状态1故障集合",
    "key": "daLiFaultOne",
    "type": "object",
    "children": [{
        "label": "单体电压过高一级告警",
        "key": "singleCellVoltageHighOneAlarmStatus"
      },
      {
        "label": "单体电压过高二级告警",
        "key": "singleCellVoltageHighTwoAlarmStatus"
      },
      {
        "label": "单体电压过低一级告警",
        "key": "singleCellVoltageLowOneAlarmStatus"
      },
      {
        "label": "单体电压过低二级告警",
        "key": "singleCellVoltageLowTwoAlarmStatus"
      },
      {
        "label": "总压过高一级告警",
        "key": "totalSingleCellVoltageHighOneAlarmStatus"
      },
      {
        "label": "总压过高二级告警",
        "key": "totalSingleCellVoltageHighTwoAlarmStatus"
      },
      {
        "label": "总压过低一级告警",
        "key": "totalSingleCellVoltageLowOneAlarmStatus"
      },
      {
        "label": "总压过低二级告警",
        "key": "totalSingleCellVoltageLowTwoAlarmStatus"
      },
      {
        "label": "充电温度过高一级告警",
        "key": "cdtemperatureHighOneAlarmStatus"
      },
      {
        "label": "充电温度过高二级告警",
        "key": "cdtemperatureHighTwoAlarmStatus"
      },
      {
        "label": "充电温度过低一级告警",
        "key": "cdtemperatureLowOneAlarmStatus"
      },
      {
        "label": "充电温度过低二级告警",
        "key": "cdtemperatureLowTwoAlarmStatus"
      },
      {
        "label": "放电温度过高一级告警",
        "key": "fdtemperatureHighOneAlarmStatus"
      },
      {
        "label": "放电温度过高二级告警",
        "key": "fdtemperatureHighTwoAlarmStatus"
      },
      {
        "label": "放电温度过低一级告警",
        "key": "fdtemperatureLowOneAlarmStatus"
      },
      {
        "label": "放电温度过低二级告警",
        "key": "fdtemperatureLowTwoAlarmStatus"
      }
    ]
  },
  {
    "label": "故障状态2故障集合",
    "key": "daLiFaultTwo",
    "type": "object",
    "children": [{
        "label": "充电过流一级告警",
        "key": "chargingCurrentHighOneAlarmStatus"
      },
      {
        "label": "充电过流二级告警",
        "key": "chargingCurrentHighTwoAlarmStatus"
      },
      {
        "label": "放电过流一级告警",
        "key": "fdCurrentHighOneAlarmStatus"
      },
      {
        "label": "放电过流二级告警",
        "key": "fdCurrentHighTwoAlarmStatus"
      },
      {
        "label": "SOC过高一级告警",
        "key": "socHighOneAlarmStatus"
      },
      {
        "label": "SOC过高二级告警",
        "key": "socHighTwoAlarmStatus"
      },
      {
        "label": "SOC过低一级告警",
        "key": "socLowOneAlarmStatus"
      },
      {
        "label": "SOC过低二级告警",
        "key": "socLowTwoAlarmStatus"
      },
      {
        "label": "压差过大一级告警值",
        "key": "differentialPressureHighOneAlarmStatus"
      },
      {
        "label": "压差过大二级告警值",
        "key": "differentialPressureHighTwoAlarmStatus"
      },
      {
        "label": "温差过大一级告警值",
        "key": "differentialTemperatureHighOneAlarmStatus"
      },
      {
        "label": "温差过大二级告警值",
        "key": "differentialTemperatureHighTwoAlarmStatus"
      }
    ]
  },
  {
    "label": "故障状态3故障集合",
    "key": "daLiFaultThree",
    "type": "object",
    "children": [{
        "label": "充电MOS过温警告",
        "key": "cdMosHighTemperatureStatus"
      },
      {
        "label": "放电MOS过温警告",
        "key": "fdMosHighTemperatureStatus"
      },
      {
        "label": "充电MOS温度检测传感器故障",
        "key": "cdMosSensorMalfunctionStatus"
      },
      {
        "label": "放电MOS温度检测传感器故障",
        "key": "fdMosSensorMalfunctionStatus"
      },
      {
        "label": "充电MOS粘连故障",
        "key": "cdMosAdhesiveMalfunctionStatus"
      },
      {
        "label": "放电MOS粘连故障",
        "key": "fdMosAdhesiveMalfunctionStatus"
      },
      {
        "label": "充电MOS断路故障",
        "key": "cdMosOpenCircuitFaultStatus"
      },
      {
        "label": "放电MOS断路故障",
        "key": "fdMosOpenCircuitFaultStatus"
      },
      {
        "label": "AFE采集芯片故障",
        "key": "afeFaultStatus"
      },
      {
        "label": "单体采集掉线",
        "key": "singleUnitCollectionDisconnectedStatus"
      },
      {
        "label": "单体温度传感器故障",
        "key": "individualTemperatureSensorMalfunctionStatus"
      },
      {
        "label": "EEPROM存储故障",
        "key": "eepromFaultStatus"
      },
      {
        "label": "RTC时钟故障",
        "key": "rtcFaultStatus"
      },
      {
        "label": "预充失败",
        "key": "preChargingFailedStatus"
      },
      {
        "label": "整车通信故障",
        "key": "vehicleCommunicationMalfunctionStatus"
      },
      {
        "label": "内网通信模块故障",
        "key": "internalNetworkCommunicationModuleMalfunctionStatus"
      }
    ]
  },
  {
    "label": "故障状态4故障集合",
    "key": "daLiFaultFour",
    "type": "object",
    "children": [{
        "label": "电流模块故障",
        "key": "currentModuleMalfunctionStatus"
      },
      {
        "label": "内总压检测模块故障",
        "key": "internalTotalPressureFaultStatus"
      },
      {
        "label": "短路保护故障",
        "key": "shortCircuitProtectionFaultStatus"
      },
      {
        "label": "低压禁止充电故障",
        "key": "lowVoltageProhibitedChargingFaultStatus"
      },
      {
        "label": "GPS或软开关断开MOS",
        "key": "gpsOrSoftSwitchDisconnectMOS"
      },
      {
        "label": "充电柜离线",
        "key": "chargingCabinetOffline"
      },
      {
        "label": "热失控故障",
        "key": "thermalRunawayFault"
      },
      {
        "label": "加热故障",
        "key": "heatingMalfunction"
      },
      {
        "label": "均衡模块通讯故障",
        "key": "balanceModuleCommunicationFailure"
      },
      {
        "label": "均衡开启条件不满足",
        "key": "equilibriumOpenConditionError"
      },
      {
        "label": "电压采集异常",
        "key": "abnormalVoltageCollection"
      },
      {
        "label": "电池充满",
        "key": "batteryFullyCharged"
      }
    ]
  },
  {
    "label": "均衡电流",
    "key": "equalizingCurrent",
    "type": "Double",
    "children": null
  },
  {
    "label": "均衡位置",
    "key": "balancedPosition",
    "type": "Integer",
    "children": null
  },
  {
    "label": "MOS温度",
    "key": "mosTemperature",
    "type": "Integer",
    "children": null
  },
  {
    "label": "预留5",
    "key": "reserve_5",
    "type": "Integer",
    "children": null
  },
  {
    "label": "预留6",
    "key": "reserve_6",
    "type": "Integer",
    "children": null
  },
  {
    "label": "预留7",
    "key": "reserve_7",
    "type": "Integer",
    "children": null
  },
  {
    "label": "预留8",
    "key": "reserve_8",
    "type": "Integer",
    "children": null
  },
  {
    "label": "sn",
    "key": "sn",
    "type": "String",
    "children": null
  },
  {
    "label": "防盗状态",
    "key": "antiTheftStatusName",
    "type": "Integer",
    "children": null
  },
  {
    "label": "加热状态",
    "key": "heatingStateName",
    "type": "Integer",
    "children": null
  },
  {
    "label": "最近一次充电时间",
    "key": "lastChargingTime",
    "type": "String",
    "children": null
  },
  {
    "label": "最近一次放电时间",
    "key": "lastDischargeTime",
    "type": "String",
    "children": null
  },
  {
    "label": "额定容量",
    "key": "ratedCapacity",
    "type": "Double",
    "children": null
  },
  {
    "label": "单体基准电压",
    "key": "individualReferenceVoltage",
    "type": "Integer",
    "children": null
  },
  {
    "label": "采集板个数",
    "key": "boardsNum",
    "type": "Integer",
    "children": null
  },
  {
    "label": "采集板1单体个数",
    "key": "boardsNumOne",
    "type": "Integer",
    "children": null
  },
  {
    "label": "采集板2单体个数",
    "key": "boardsNumTwo",
    "type": "Integer",
    "children": null
  },
  {
    "label": "采集板3单体个数",
    "key": "boardsNumThree",
    "type": "Integer",
    "children": null
  },
  {
    "label": "采集板1温度个数",
    "key": "boardsTemperatureNumOne",
    "type": "Integer",
    "children": null
  },
  {
    "label": "采集板2温度个数",
    "key": "boardsTemperatureNumTwo",
    "type": "Integer",
    "children": null
  },
  {
    "label": "采集板3温度个数",
    "key": "boardsTemperatureNumThree",
    "type": "Integer",
    "children": null
  },
  {
    "label": "电池类型",
    "key": "batteryTypeName",
    "type": "Integer",
    "children": null
  },
  {
    "label": "休眠等待时间",
    "key": "waitTime",
    "type": "Integer",
    "children": null
  },
  {
    "label": "单体电压过高一级告警",
    "key": "singleCellVoltageHighOneAlarm",
    "type": "Integer",
    "children": null
  },
  {
    "label": "单体电压过高二级告警",
    "key": "singleCellVoltageHighTwoAlarm",
    "type": "Integer",
    "children": null
  },
  {
    "label": "单体电压过低一级告警",
    "key": "singleCellVoltageLowOneAlarm",
    "type": "Integer",
    "children": null
  },
  {
    "label": "单体电压过低二级告警",
    "key": "singleCellVoltageLowTwoAlarm",
    "type": "Integer",
    "children": null
  },
  {
    "label": "总压过高一级告警",
    "key": "totalSingleCellVoltageHighOneAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "总压过高二级告警",
    "key": "totalSingleCellVoltageHighTwoAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "总压过低一级告警",
    "key": "totalSingleCellVoltageLowOneAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "总压过低二级告警",
    "key": "totalSingleCellVoltageLowTwoAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "充电电流过高一级告警",
    "key": "chargingCurrentHighOneAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "充电电流过高二级告警",
    "key": "chargingCurrentHighTwoAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "放电电流过高一级告警",
    "key": "fdCurrentHighOneAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "放电电流过高二级告警",
    "key": "fdCurrentHighTwoAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "充电温度过高一级告警",
    "key": "cdtemperatureHighOneAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "充电温度过高二级告警",
    "key": "cdtemperatureHighTwoAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "充电温度过低一级告警",
    "key": "cdtemperatureLowOneAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "充电温度过低二级告警",
    "key": "cdtemperatureLowTwoAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "放电温度过高一级告警",
    "key": "fdtemperatureHighOneAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "放电温度过高二级告警",
    "key": "fdtemperatureHighTwoAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "放电温度过低一级告警",
    "key": "fdtemperatureLowOneAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "放电温度过低二级告警",
    "key": "fdtemperatureLowTwoAlarm",
    "type": "Double",
    "children": null
  },
  {
    "label": "压差过大一级告警值",
    "key": "differentialPressureHighOneAlarm",
    "type": "Integer",
    "children": null
  },
  {
    "label": "压差过大二级告警值",
    "key": "differentialPressureHighTwoAlarm",
    "type": "Integer",
    "children": null
  },
  {
    "label": "温差过大一级告警值",
    "key": "differentialTemperatureHighOneAlarm",
    "type": "Integer",
    "children": null
  },
  {
    "label": "温差过大二级告警值",
    "key": "differentialTemperatureHighTwoAlarm",
    "type": "Integer",
    "children": null
  },
  {
    "label": "均衡开启电压",
    "key": "balancedVoltage",
    "type": "Integer",
    "children": null
  },
  {
    "label": "均衡开启压差",
    "key": "balancedPressure",
    "type": "Integer",
    "children": null
  },
  {
    "label": "充电MOS管开关控制",
    "key": "cdMosControlName",
    "type": "Integer",
    "children": null
  },
  {
    "label": "放电MOS管开关控制",
    "key": "fdMosControl",
    "type": "Integer",
    "children": null
  },
  {
    "label": "放电MOS管开关控制",
    "key": "fdMosControlName",
    "type": "String",
    "children": null
  },
  {
    "label": "SOC设置",
    "key": "socSet",
    "type": "Integer",
    "children": null
  },
  {
    "label": "功率管温度保护告警",
    "key": "powerTubeTemperatureprotectionAlarm",
    "type": "Integer",
    "children": null
  },
  {
    "label": "软件版本号",
    "key": "softwareVersion",
    "type": "String",
    "children": null
  },
  {
    "label": "硬件版本号",
    "key": "hardwareVersion",
    "type": "String",
    "children": null
  },
  {
    "label": "机器编码",
    "key": "code",
    "type": "String",
    "children": null
  },
  {
    "label": "参数设置密码",
    "key": "paramSetPassword",
    "type": "String",
    "children": null
  },
  {
    "label": "生产日期",
    "key": "dateOfManufacture",
    "type": "String",
    "children": null
  },
  {
    "label": "电池串数",
    "key": "batteryStringsNum",
    "type": "Integer",
    "children": null
  },
  {
    "label": "主动均衡开关",
    "key": "activeBalanceSwitchName",
    "type": "Integer",
    "children": null
  },
  {
    "label": "主动均衡电流",
    "key": "activeCurrentBalancing",
    "type": "Double",
    "children": null
  },
  {
    "label": "通信方式",
    "key": "communicationName",
    "type": "Integer",
    "children": null
  },
  {
    "label": "逆变器制造商",
    "key": "inverterManufacturerName",
    "type": "Integer",
    "children": null
  },
  {
    "label": "rtc",
    "key": "rtc",
    "type": "String",
    "children": null
  },
  {
    "label": "强制启动开关",
    "key": "forceStartSwitch",
    "type": "Integer",
    "children": null
  },
  {
    "label": "加热开关",
    "key": "heatingSwitchName",
    "type": "Integer",
    "children": null
  },
  {
    "label": "SOC过高告警值",
    "key": "socHighAlarmValue",
    "type": "Double",
    "children": null
  },
  {
    "label": "SOC过高告警恢复值",
    "key": "socHighAlarmRecoveryValue",
    "type": "Double",
    "children": null
  },
  {
    "label": "SOC过低告警值",
    "key": "socLowAlarmValue",
    "type": "Double",
    "children": null
  },
  {
    "label": "SOC过低告警恢复值",
    "key": "socLowAlarmRecoveryValue",
    "type": "Double",
    "children": null
  },
  {
    "label": "灯光告警或蜂鸣器告警",
    "key": "lightAlarmOrBuzzerAlarm",
    "type": "Integer",
    "children": null
  },
  {
    "label": "灯光告警或蜂鸣器告警名称",
    "key": "lightAlarmOrBuzzerAlarmName",
    "type": "String",
    "children": null
  },
  {
    "label": "电压校准",
    "key": "voltageCalibration",
    "type": "Double",
    "children": null
  },
  {
    "label": "x轴加速度",
    "key": "xacceleration",
    "type": "Integer",
    "children": null
  },
  {
    "label": "y轴加速度",
    "key": "yacceleration",
    "type": "Integer",
    "children": null
  },
  {
    "label": "z轴加速度",
    "key": "zacceleration",
    "type": "Integer",
    "children": null
  },
  {
    "label": "解锁状态控制",
    "key": "unlockStateControlName",
    "type": "Integer",
    "children": null
  },
  {
    "label": "均衡截止电压",
    "key": "balancedCutOffVoltage",
    "type": "Integer",
    "children": null
  },
  {
    "label": "加热开启温度",
    "key": "heatingActivationTemperature",
    "type": "Integer",
    "children": null
  },
  {
    "label": "钥匙逻辑",
    "key": "keyLogicName",
    "type": "Integer",
    "children": null
  },
  {
    "label": "均衡宝印规版本启用开关",
    "key": "balancedTreasureName",
    "type": "Integer",
    "children": null
  },
]

export const jsonData = {
  "list": {
    "type": "array",
    "description": "单体电池电压集合",
    "items": {
      "type": "object",
      "description": "单体电池电压集合",
      "properties": {
        "address": {
          "type": "Integer",
          "description": "地址",
          "mock": {
            "mock": "@integer"
          }
        },
        "cellVoltage": {
          "type": "Double",
          "description": "电压",
          "mock": {
            "mock": "@float"
          }
        }
      },
      "required": []
    }
  },
  "temperatures": {
    "type": "array",
    "description": "电池温度集合",
    "items": {
      "type": "object",
      "description": "电池温度集合",
      "properties": {
        "address": {
          "type": "Integer",
          "description": "地址",
          "mock": {
            "mock": "@integer"
          }
        },
        "temperature": {
          "type": "Integer",
          "description": "电池温度",
          "mock": {
            "mock": "@integer"
          }
        }
      },
      "required": []
    }
  },
  "totalBatteryVoltage": {
    "type": "Double",
    "description": "电池总电压",
    "mock": {
      "mock": "@float"
    }
  },
  "currentData": {
    "type": "Double",
    "description": "电流数据",
    "mock": {
      "mock": "@float"
    }
  },
  "soc": {
    "type": "Double",
    "description": "soc",
    "mock": {
      "mock": "@float"
    }
  },
  "maxSingleCellVoltage": {
    "type": "Integer",
    "description": "最高单体电压",
    "mock": {
      "mock": "@integer"
    }
  },
  "minSingleCellVoltage": {
    "type": "Integer",
    "description": "最低单体电压",
    "mock": {
      "mock": "@integer"
    }
  },
  "maxBatteryTemperature": {
    "type": "Integer",
    "description": "最高单体温度",
    "mock": {
      "mock": "@integer"
    }
  },
  "minBatteryTemperature": {
    "type": "Integer",
    "description": "最低单体温度",
    "mock": {
      "mock": "@integer"
    }
  },
  "cdStatus": {
    "type": "Integer",
    "description": "充放电状态",
    "mock": {
      "mock": "@integer"
    }
  },
  "remainingBatteryCapacity": {
    "type": "Double",
    "description": "电池剩余容量",
    "mock": {
      "mock": "@float"
    }
  },
  "batteryNum": {
    "type": "Integer",
    "description": "电池数量",
    "mock": {
      "mock": "@integer"
    }
  },
  "cgqNum": {
    "type": "Integer",
    "description": "电池温度传感器数量",
    "mock": {
      "mock": "@integer"
    }
  },
  "cyclesNum": {
    "type": "Integer",
    "description": "电池使用循环次数",
    "mock": {
      "mock": "@integer"
    }
  },
  "equilibriumState": {
    "type": "Integer",
    "description": "均衡状态",
    "mock": {
      "mock": "@integer"
    }
  },
  "cdMosState": {
    "type": "Integer",
    "description": "充电MOS状态",
    "mock": {
      "mock": "@integer"
    }
  },
  "fdMosState": {
    "type": "Integer",
    "description": "放电MOS状态",
    "mock": {
      "mock": "@integer"
    }
  },
  "avgVoltage": {
    "type": "Integer",
    "description": "平均电压",
    "mock": {
      "mock": "@integer"
    }
  },
  "differentialPressure": {
    "type": "Integer",
    "description": "压差",
    "mock": {
      "mock": "@integer"
    }
  },
  "power": {
    "type": "Integer",
    "description": "功率",
    "mock": {
      "mock": "@integer"
    }
  },
  "faultStatusOne": {
    "type": "Integer",
    "description": "故障状态1",
    "mock": {
      "mock": "@integer"
    }
  },
  "daLiFaultOne": {
    "type": "object",
    "description": "故障状态1故障集合",
    "properties": {
      "singleCellVoltageHighOneAlarmStatus": {
        "type": "Integer",
        "description": "单体电压过高一级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "singleCellVoltageHighTwoAlarmStatus": {
        "type": "Integer",
        "description": "单体电压过高二级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "singleCellVoltageLowOneAlarmStatus": {
        "type": "Integer",
        "description": "单体电压过低一级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "singleCellVoltageLowTwoAlarmStatus": {
        "type": "Integer",
        "description": "单体电压过低二级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "totalSingleCellVoltageHighOneAlarmStatus": {
        "type": "Integer",
        "description": "总压过高一级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "totalSingleCellVoltageHighTwoAlarmStatus": {
        "type": "Integer",
        "description": "总压过高二级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "totalSingleCellVoltageLowOneAlarmStatus": {
        "type": "Integer",
        "description": "总压过低一级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "totalSingleCellVoltageLowTwoAlarmStatus": {
        "type": "Integer",
        "description": "总压过低二级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "cdtemperatureHighOneAlarmStatus": {
        "type": "Integer",
        "description": "充电温度过高一级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "cdtemperatureHighTwoAlarmStatus": {
        "type": "Integer",
        "description": "充电温度过高二级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "cdtemperatureLowOneAlarmStatus": {
        "type": "Integer",
        "description": "充电温度过低一级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "cdtemperatureLowTwoAlarmStatus": {
        "type": "Integer",
        "description": "充电温度过低二级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "fdtemperatureHighOneAlarmStatus": {
        "type": "Integer",
        "description": "放电温度过高一级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "fdtemperatureHighTwoAlarmStatus": {
        "type": "Integer",
        "description": "放电温度过高二级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "fdtemperatureLowOneAlarmStatus": {
        "type": "Integer",
        "description": "放电温度过低一级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "fdtemperatureLowTwoAlarmStatus": {
        "type": "Integer",
        "description": "放电温度过低二级告警",
        "mock": {
          "mock": "@integer"
        }
      }
    },
    "required": []
  },
  "faultStatusTwo": {
    "type": "Integer",
    "description": "故障状态2",
    "mock": {
      "mock": "@integer"
    }
  },
  "daLiFaultTwo": {
    "type": "object",
    "description": "故障状态2故障集合",
    "properties": {
      "chargingCurrentHighOneAlarmStatus": {
        "type": "Integer",
        "description": "充电过流一级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "chargingCurrentHighTwoAlarmStatus": {
        "type": "Integer",
        "description": "充电过流二级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "fdCurrentHighOneAlarmStatus": {
        "type": "Integer",
        "description": "放电过流一级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "fdCurrentHighTwoAlarmStatus": {
        "type": "Integer",
        "description": "放电过流二级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "socHighOneAlarmStatus": {
        "type": "Integer",
        "description": "SOC过高一级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "socHighTwoAlarmStatus": {
        "type": "Integer",
        "description": "SOC过高二级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "socLowOneAlarmStatus": {
        "type": "Integer",
        "description": "SOC过低一级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "socLowTwoAlarmStatus": {
        "type": "Integer",
        "description": "SOC过低二级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "differentialPressureHighOneAlarmStatus": {
        "type": "Integer",
        "description": "压差过大一级告警值",
        "mock": {
          "mock": "@integer"
        }
      },
      "differentialPressureHighTwoAlarmStatus": {
        "type": "Integer",
        "description": "压差过大二级告警值",
        "mock": {
          "mock": "@integer"
        }
      },
      "differentialTemperatureHighOneAlarmStatus": {
        "type": "Integer",
        "description": "温差过大一级告警值",
        "mock": {
          "mock": "@integer"
        }
      },
      "differentialTemperatureHighTwoAlarmStatus": {
        "type": "Integer",
        "description": "温差过大二级告警值",
        "mock": {
          "mock": "@integer"
        }
      }
    },
    "required": []
  },
  "faultStatusThree": {
    "type": "Integer",
    "description": "故障状态3",
    "mock": {
      "mock": "@integer"
    }
  },
  "daLiFaultThree": {
    "type": "object",
    "description": "故障状态3故障集合",
    "properties": {
      "cdMosHighTemperatureStatus": {
        "type": "Integer",
        "description": "充电MOS过温警告",
        "mock": {
          "mock": "@integer"
        }
      },
      "fdMosHighTemperatureStatus": {
        "type": "Integer",
        "description": "放电MOS过温警告",
        "mock": {
          "mock": "@integer"
        }
      },
      "cdMosSensorMalfunctionStatus": {
        "type": "Integer",
        "description": "充电MOS温度检测传感器故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "fdMosSensorMalfunctionStatus": {
        "type": "Integer",
        "description": "放电MOS温度检测传感器故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "cdMosAdhesiveMalfunctionStatus": {
        "type": "Integer",
        "description": "充电MOS粘连故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "fdMosAdhesiveMalfunctionStatus": {
        "type": "Integer",
        "description": "放电MOS粘连故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "cdMosOpenCircuitFaultStatus": {
        "type": "Integer",
        "description": "充电MOS断路故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "fdMosOpenCircuitFaultStatus": {
        "type": "Integer",
        "description": "放电MOS断路故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "afeFaultStatus": {
        "type": "Integer",
        "description": "AFE采集芯片故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "singleUnitCollectionDisconnectedStatus": {
        "type": "Integer",
        "description": "单体采集掉线",
        "mock": {
          "mock": "@integer"
        }
      },
      "individualTemperatureSensorMalfunctionStatus": {
        "type": "Integer",
        "description": "单体温度传感器故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "eepromFaultStatus": {
        "type": "Integer",
        "description": "EEPROM存储故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "rtcFaultStatus": {
        "type": "Integer",
        "description": "RTC时钟故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "preChargingFailedStatus": {
        "type": "Integer",
        "description": "预充失败",
        "mock": {
          "mock": "@integer"
        }
      },
      "vehicleCommunicationMalfunctionStatus": {
        "type": "Integer",
        "description": "整车通信故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "internalNetworkCommunicationModuleMalfunctionStatus": {
        "type": "Integer",
        "description": "内网通信模块故障",
        "mock": {
          "mock": "@integer"
        }
      }
    },
    "required": []
  },
  "faultStatusFour": {
    "type": "Integer",
    "description": "故障状态4",
    "mock": {
      "mock": "@integer"
    }
  },
  "daLiFaultFour": {
    "type": "object",
    "description": "故障状态4故障集合",
    "properties": {
      "currentModuleMalfunctionStatus": {
        "type": "Integer",
        "description": "电流模块故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "internalTotalPressureFaultStatus": {
        "type": "Integer",
        "description": "内总压检测模块故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "shortCircuitProtectionFaultStatus": {
        "type": "Integer",
        "description": "短路保护故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "lowVoltageProhibitedChargingFaultStatus": {
        "type": "Integer",
        "description": "低压禁止充电故障",
        "mock": {
          "mock": "@integer"
        }
      }
    },
    "required": []
  },
  "remainingMileage": {
    "type": "Double",
    "description": "剩余里程",
    "mock": {
      "mock": "@float"
    }
  },
  "activeEquilibriumState": {
    "type": "Integer",
    "description": "主动均衡状态",
    "mock": {
      "mock": "@integer"
    }
  },
  "equalizingCurrent": {
    "type": "Double",
    "description": "均衡电流",
    "mock": {
      "mock": "@float"
    }
  },
  "balancedPosition": {
    "type": "Integer",
    "description": "均衡位置",
    "mock": {
      "mock": "@integer"
    }
  },
  "mosTemperature": {
    "type": "Integer",
    "description": "MOS温度",
    "mock": {
      "mock": "@integer"
    }
  },
  "reserve_5": {
    "type": "Integer",
    "description": "预留5",
    "mock": {
      "mock": "@integer"
    }
  },
  "reserve_6": {
    "type": "Integer",
    "description": "预留6",
    "mock": {
      "mock": "@integer"
    }
  },
  "reserve_7": {
    "type": "Integer",
    "description": "预留7",
    "mock": {
      "mock": "@integer"
    }
  },
  "reserve_8": {
    "type": "Integer",
    "description": "预留8",
    "mock": {
      "mock": "@integer"
    }
  },
  "sn": {
    "type": "String",
    "description": "sn",
    "mock": {
      "mock": "@string"
    }
  },
  "antiTheftStatus": {
    "type": "Integer",
    "description": "防盗状态",
    "mock": {
      "mock": "@integer"
    }
  },
  "heatingState": {
    "type": "Integer",
    "description": "加热状态",
    "mock": {
      "mock": "@integer"
    }
  },
  "lastChargingTime": {
    "type": "String",
    "description": "最近一次充电时间",
    "mock": {
      "mock": "@string"
    }
  },
  "lastDischargeTime": {
    "type": "String",
    "description": "最近一次放电时间",
    "mock": {
      "mock": "@string"
    }
  },
  "ratedCapacity": {
    "type": "Double",
    "description": "额定容量",
    "mock": {
      "mock": "@float"
    }
  },
  "individualReferenceVoltage": {
    "type": "Integer",
    "description": "单体基准电压",
    "mock": {
      "mock": "@integer"
    }
  },
  "boardsNum": {
    "type": "Integer",
    "description": "采集板个数",
    "mock": {
      "mock": "@integer"
    }
  },
  "boardsNumOne": {
    "type": "Integer",
    "description": "采集板1单体个数",
    "mock": {
      "mock": "@integer"
    }
  },
  "boardsNumTwo": {
    "type": "Integer",
    "description": "采集板2单体个数",
    "mock": {
      "mock": "@integer"
    }
  },
  "boardsNumThree": {
    "type": "Integer",
    "description": "采集板3单体个数",
    "mock": {
      "mock": "@integer"
    }
  },
  "boardsTemperatureNumOne": {
    "type": "Integer",
    "description": "采集板1温度个数",
    "mock": {
      "mock": "@integer"
    }
  },
  "boardsTemperatureNumTwo": {
    "type": "Integer",
    "description": "采集板2温度个数",
    "mock": {
      "mock": "@integer"
    }
  },
  "boardsTemperatureNumThree": {
    "type": "Integer",
    "description": "采集板3温度个数",
    "mock": {
      "mock": "@integer"
    }
  },
  "batteryType": {
    "type": "Integer",
    "description": "电池类型",
    "mock": {
      "mock": "@integer"
    }
  },
  "waitTime": {
    "type": "Integer",
    "description": "休眠等待时间",
    "mock": {
      "mock": "@integer"
    }
  },
  "singleCellVoltageHighOneAlarm": {
    "type": "Integer",
    "description": "单体电压过高一级告警",
    "mock": {
      "mock": "@integer"
    }
  },
  "singleCellVoltageHighTwoAlarm": {
    "type": "Integer",
    "description": "单体电压过高二级告警",
    "mock": {
      "mock": "@integer"
    }
  },
  "singleCellVoltageLowOneAlarm": {
    "type": "Integer",
    "description": "单体电压过低一级告警",
    "mock": {
      "mock": "@integer"
    }
  },
  "singleCellVoltageLowTwoAlarm": {
    "type": "Integer",
    "description": "单体电压过低二级告警",
    "mock": {
      "mock": "@integer"
    }
  },
  "totalSingleCellVoltageHighOneAlarm": {
    "type": "Double",
    "description": "总压过高一级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "totalSingleCellVoltageHighTwoAlarm": {
    "type": "Double",
    "description": "总压过高二级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "totalSingleCellVoltageLowOneAlarm": {
    "type": "Double",
    "description": "总压过低一级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "totalSingleCellVoltageLowTwoAlarm": {
    "type": "Double",
    "description": "总压过低二级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "chargingCurrentHighOneAlarm": {
    "type": "Double",
    "description": "充电电流过高一级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "chargingCurrentHighTwoAlarm": {
    "type": "Double",
    "description": "充电电流过高二级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "fdCurrentHighOneAlarm": {
    "type": "Double",
    "description": "放电电流过高一级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "fdCurrentHighTwoAlarm": {
    "type": "Double",
    "description": "放电电流过高二级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "cdtemperatureHighOneAlarm": {
    "type": "Double",
    "description": "充电温度过高一级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "cdtemperatureHighTwoAlarm": {
    "type": "Double",
    "description": "充电温度过高二级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "cdtemperatureLowOneAlarm": {
    "type": "Double",
    "description": "充电温度过低一级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "cdtemperatureLowTwoAlarm": {
    "type": "Double",
    "description": "充电温度过低二级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "fdtemperatureHighOneAlarm": {
    "type": "Double",
    "description": "放电温度过高一级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "fdtemperatureHighTwoAlarm": {
    "type": "Double",
    "description": "放电温度过高二级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "fdtemperatureLowOneAlarm": {
    "type": "Double",
    "description": "放电温度过低一级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "fdtemperatureLowTwoAlarm": {
    "type": "Double",
    "description": "放电温度过低二级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "differentialPressureHighOneAlarm": {
    "type": "Integer",
    "description": "压差过大一级告警值",
    "mock": {
      "mock": "@integer"
    }
  },
  "differentialPressureHighTwoAlarm": {
    "type": "Integer",
    "description": "压差过大二级告警值",
    "mock": {
      "mock": "@integer"
    }
  },
  "differentialTemperatureHighOneAlarm": {
    "type": "Integer",
    "description": "温差过大一级告警值",
    "mock": {
      "mock": "@integer"
    }
  },
  "differentialTemperatureHighTwoAlarm": {
    "type": "Integer",
    "description": "温差过大二级告警值",
    "mock": {
      "mock": "@integer"
    }
  },
  "balancedVoltage": {
    "type": "Integer",
    "description": "均衡开启电压",
    "mock": {
      "mock": "@integer"
    }
  },
  "balancedPressure": {
    "type": "Integer",
    "description": "均衡开启压差",
    "mock": {
      "mock": "@integer"
    }
  },
  "cdMosControl": {
    "type": "Integer",
    "description": "充电MOS管开关控制",
    "mock": {
      "mock": "@integer"
    }
  },
  "fdMosControl": {
    "type": "Integer",
    "description": "放电MOS管开关控制",
    "mock": {
      "mock": "@integer"
    }
  },
  "socSet": {
    "type": "Integer",
    "description": "SOC设置",
    "mock": {
      "mock": "@integer"
    }
  },
  "powerTubeTemperatureprotectionAlarm": {
    "type": "Integer",
    "description": "功率管温度保护告警",
    "mock": {
      "mock": "@integer"
    }
  },
  "softwareVersion": {
    "type": "String",
    "description": "软件版本号",
    "mock": {
      "mock": "@string"
    }
  },
  "hardwareVersion": {
    "type": "String",
    "description": "硬件版本号",
    "mock": {
      "mock": "@string"
    }
  },
  "code": {
    "type": "String",
    "description": "机器编码",
    "mock": {
      "mock": "@string"
    }
  },
  "systemRestart": {
    "type": "Integer",
    "description": "系统重启",
    "mock": {
      "mock": "@integer"
    }
  },
  "systemClose": {
    "type": "Integer",
    "description": "关闭系统",
    "mock": {
      "mock": "@integer"
    }
  },
  "shutDownSystem": {
    "type": "Integer",
    "description": "电流归零",
    "mock": {
      "mock": "@integer"
    }
  },
  "restoreFactorySettings": {
    "type": "Integer",
    "description": "恢复出厂设置",
    "mock": {
      "mock": "@integer"
    }
  },
  "paramSetPassword": {
    "type": "String",
    "description": "参数设置密码",
    "mock": {
      "mock": "@string"
    }
  },
  "dateOfManufacture": {
    "type": "String",
    "description": "生产日期",
    "mock": {
      "mock": "@string"
    }
  },
  "batteryStringsNum": {
    "type": "Integer",
    "description": "电池串数",
    "mock": {
      "mock": "@integer"
    }
  },
  "activeBalanceSwitch": {
    "type": "Integer",
    "description": "主动均衡开关",
    "mock": {
      "mock": "@integer"
    }
  },
  "activeCurrentBalancing": {
    "type": "Double",
    "description": "主动均衡电流",
    "mock": {
      "mock": "@float"
    }
  },
  "communication": {
    "type": "Integer",
    "description": "通信方式0：RS485，1：CAN，其他预留，0xFF无效",
    "mock": {
      "mock": "@integer"
    }
  },
  "inverterManufacturer": {
    "type": "Integer",
    "description": "逆变器制造商,0：NONE,,1：PYLON,,2：GROWAT,,3：SOFAR,,4：VOLTRONICPOWER,,5：GOODWE,,6：SRNE,,7：MUST,,8：VICTRONENERGY,,9:SMA,,10:DEYE,,11:AISWEI,,12:SACOLAR,,13:SOLARK,,14:XMT,,15:SOLIS,,16:LUXPOWERTEK,,17:STUDER,,18:SOROTEC,,0xFF：无效",
    "mock": {
      "mock": "@integer"
    }
  },
  "rtc": {
    "type": "String",
    "description": "rtc",
    "mock": {
      "mock": "@string"
    }
  },
  "forceStartSwitch": {
    "type": "Integer",
    "description": "强制启动开关",
    "mock": {
      "mock": "@integer"
    }
  },
  "heatingSwitch": {
    "type": "Integer",
    "description": "加热开关",
    "mock": {
      "mock": "@integer"
    }
  },
  "socHighAlarmValue": {
    "type": "Double",
    "description": "SOC过高告警值",
    "mock": {
      "mock": "@float"
    }
  },
  "socHighAlarmRecoveryValue": {
    "type": "Double",
    "description": "SOC过高告警恢复值",
    "mock": {
      "mock": "@float"
    }
  },
  "socLowAlarmValue": {
    "type": "Double",
    "description": "SOC过低告警值",
    "mock": {
      "mock": "@float"
    }
  },
  "socLowAlarmRecoveryValue": {
    "type": "Double",
    "description": "SOC过低告警恢复值",
    "mock": {
      "mock": "@float"
    }
  },
  "lightAlarmOrBuzzerAlarm": {
    "type": "Integer",
    "description": "灯光告警或蜂鸣器告警",
    "mock": {
      "mock": "@integer"
    }
  },
  "voltageCalibration": {
    "type": "Double",
    "description": "电压校准",
    "mock": {
      "mock": "@float"
    }
  },
  "xacceleration": {
    "type": "Integer",
    "description": "x轴加速度",
    "mock": {
      "mock": "@integer"
    }
  },
  "yacceleration": {
    "type": "Integer",
    "description": "y轴加速度",
    "mock": {
      "mock": "@integer"
    }
  },
  "zacceleration": {
    "type": "Integer",
    "description": "z轴加速度",
    "mock": {
      "mock": "@integer"
    }
  },
  "unlockStateControl": {
    "type": "Integer",
    "description": "解锁状态",
    "mock": {
      "mock": "@integer"
    }
  },
  "balancedCutOffVoltage": {
    "type": "Integer",
    "description": "均衡截止电压",
    "mock": {
      "mock": "@integer"
    }
  },
  "heatingActivationTemperature": {
    "type": "Integer",
    "description": "加热开启温度",
    "mock": {
      "mock": "@integer"
    }
  },
  "keyLogic": {
    "type": "Integer",
    "description": "钥匙逻辑",
    "mock": {
      "mock": "@integer"
    }
  },
  "balancedTreasure": {
    "type": "Integer",
    "description": "均衡宝印规版本启用开关",
    "mock": {
      "mock": "@integer"
    }
  }
}

export const jsonData2 = {
  "list": {
    "type": "array",
    "description": "单体电池电压集合",
    "items": {
      "type": "object",
      "description": "单体电池电压集合",
      "properties": {
        "address": {
          "type": "Integer",
          "description": "地址",
          "mock": {
            "mock": "@integer"
          }
        },
        "cellVoltage": {
          "type": "Double",
          "description": "电压",
          "mock": {
            "mock": "@float"
          }
        }
      },
      "required": []
    }
  },
  "temperatures": {
    "type": "array",
    "description": "电池温度集合",
    "items": {
      "type": "object",
      "description": "电池温度集合",
      "properties": {
        "address": {
          "type": "Integer",
          "description": "地址",
          "mock": {
            "mock": "@integer"
          }
        },
        "temperature": {
          "type": "Integer",
          "description": "电池温度",
          "mock": {
            "mock": "@integer"
          }
        }
      },
      "required": []
    }
  },
  "totalBatteryVoltage": {
    "type": "Double",
    "description": "电池总电压",
    "mock": {
      "mock": "@float"
    }
  },
  "currentData": {
    "type": "Double",
    "description": "电流数据",
    "mock": {
      "mock": "@float"
    }
  },
  "soc": {
    "type": "Double",
    "description": "soc",
    "mock": {
      "mock": "@float"
    }
  },
  "maxSingleCellVoltage": {
    "type": "Integer",
    "description": "最高单体电压",
    "mock": {
      "mock": "@integer"
    }
  },
  "minSingleCellVoltage": {
    "type": "Integer",
    "description": "最低单体电压",
    "mock": {
      "mock": "@integer"
    }
  },
  "maxBatteryTemperature": {
    "type": "Integer",
    "description": "最高单体温度",
    "mock": {
      "mock": "@integer"
    }
  },
  "minBatteryTemperature": {
    "type": "Integer",
    "description": "最低单体温度",
    "mock": {
      "mock": "@integer"
    }
  },
  "cdStatus": {
    "type": "Integer",
    "description": "充放电状态",
    "mock": {
      "mock": "@integer"
    }
  },
  "cdStatusName": {
    "type": "String",
    "description": "充放电状态名称",
    "mock": {
      "mock": "@string"
    }
  },
  "remainingBatteryCapacity": {
    "type": "Double",
    "description": "电池剩余容量",
    "mock": {
      "mock": "@float"
    }
  },
  "batteryNum": {
    "type": "Integer",
    "description": "电池数量",
    "mock": {
      "mock": "@integer"
    }
  },
  "cgqNum": {
    "type": "Integer",
    "description": "电池温度传感器数量",
    "mock": {
      "mock": "@integer"
    }
  },
  "cyclesNum": {
    "type": "Integer",
    "description": "电池使用循环次数",
    "mock": {
      "mock": "@integer"
    }
  },
  "equilibriumState": {
    "type": "Integer",
    "description": "均衡状态",
    "mock": {
      "mock": "@integer"
    }
  },
  "equilibriumStateName": {
    "type": "String",
    "description": "均衡状态名称",
    "mock": {
      "mock": "@string"
    }
  },
  "cdMosState": {
    "type": "Integer",
    "description": "充电MOS状态",
    "mock": {
      "mock": "@integer"
    }
  },
  "cdMosStateName": {
    "type": "String",
    "description": "充电MOS状态名称",
    "mock": {
      "mock": "@string"
    }
  },
  "fdMosState": {
    "type": "Integer",
    "description": "放电MOS状态",
    "mock": {
      "mock": "@integer"
    }
  },
  "fdMosStateName": {
    "type": "String",
    "description": "放电MOS状态名称",
    "mock": {
      "mock": "@string"
    }
  },
  "avgVoltage": {
    "type": "Integer",
    "description": "平均电压",
    "mock": {
      "mock": "@integer"
    }
  },
  "differentialPressure": {
    "type": "Integer",
    "description": "压差",
    "mock": {
      "mock": "@integer"
    }
  },
  "power": {
    "type": "Integer",
    "description": "功率",
    "mock": {
      "mock": "@integer"
    }
  },
  "faultStatusOne": {
    "type": "Integer",
    "description": "故障状态1",
    "mock": {
      "mock": "@integer"
    }
  },
  "daLiFaultOne": {
    "type": "object",
    "description": "故障状态1故障集合",
    "properties": {
      "singleCellVoltageHighOneAlarmStatus": {
        "type": "Integer",
        "description": "单体电压过高一级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "singleCellVoltageHighTwoAlarmStatus": {
        "type": "Integer",
        "description": "单体电压过高二级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "singleCellVoltageLowOneAlarmStatus": {
        "type": "Integer",
        "description": "单体电压过低一级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "singleCellVoltageLowTwoAlarmStatus": {
        "type": "Integer",
        "description": "单体电压过低二级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "totalSingleCellVoltageHighOneAlarmStatus": {
        "type": "Integer",
        "description": "总压过高一级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "totalSingleCellVoltageHighTwoAlarmStatus": {
        "type": "Integer",
        "description": "总压过高二级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "totalSingleCellVoltageLowOneAlarmStatus": {
        "type": "Integer",
        "description": "总压过低一级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "totalSingleCellVoltageLowTwoAlarmStatus": {
        "type": "Integer",
        "description": "总压过低二级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "cdtemperatureHighOneAlarmStatus": {
        "type": "Integer",
        "description": "充电温度过高一级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "cdtemperatureHighTwoAlarmStatus": {
        "type": "Integer",
        "description": "充电温度过高二级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "cdtemperatureLowOneAlarmStatus": {
        "type": "Integer",
        "description": "充电温度过低一级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "cdtemperatureLowTwoAlarmStatus": {
        "type": "Integer",
        "description": "充电温度过低二级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "fdtemperatureHighOneAlarmStatus": {
        "type": "Integer",
        "description": "放电温度过高一级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "fdtemperatureHighTwoAlarmStatus": {
        "type": "Integer",
        "description": "放电温度过高二级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "fdtemperatureLowOneAlarmStatus": {
        "type": "Integer",
        "description": "放电温度过低一级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "fdtemperatureLowTwoAlarmStatus": {
        "type": "Integer",
        "description": "放电温度过低二级告警",
        "mock": {
          "mock": "@integer"
        }
      }
    },
    "required": []
  },
  "faultStatusTwo": {
    "type": "Integer",
    "description": "故障状态2",
    "mock": {
      "mock": "@integer"
    }
  },
  "daLiFaultTwo": {
    "type": "object",
    "description": "故障状态2故障集合",
    "properties": {
      "chargingCurrentHighOneAlarmStatus": {
        "type": "Integer",
        "description": "充电过流一级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "chargingCurrentHighTwoAlarmStatus": {
        "type": "Integer",
        "description": "充电过流二级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "fdCurrentHighOneAlarmStatus": {
        "type": "Integer",
        "description": "放电过流一级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "fdCurrentHighTwoAlarmStatus": {
        "type": "Integer",
        "description": "放电过流二级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "socHighOneAlarmStatus": {
        "type": "Integer",
        "description": "SOC过高一级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "socHighTwoAlarmStatus": {
        "type": "Integer",
        "description": "SOC过高二级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "socLowOneAlarmStatus": {
        "type": "Integer",
        "description": "SOC过低一级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "socLowTwoAlarmStatus": {
        "type": "Integer",
        "description": "SOC过低二级告警",
        "mock": {
          "mock": "@integer"
        }
      },
      "differentialPressureHighOneAlarmStatus": {
        "type": "Integer",
        "description": "压差过大一级告警值",
        "mock": {
          "mock": "@integer"
        }
      },
      "differentialPressureHighTwoAlarmStatus": {
        "type": "Integer",
        "description": "压差过大二级告警值",
        "mock": {
          "mock": "@integer"
        }
      },
      "differentialTemperatureHighOneAlarmStatus": {
        "type": "Integer",
        "description": "温差过大一级告警值",
        "mock": {
          "mock": "@integer"
        }
      },
      "differentialTemperatureHighTwoAlarmStatus": {
        "type": "Integer",
        "description": "温差过大二级告警值",
        "mock": {
          "mock": "@integer"
        }
      }
    },
    "required": []
  },
  "faultStatusThree": {
    "type": "Integer",
    "description": "故障状态3",
    "mock": {
      "mock": "@integer"
    }
  },
  "daLiFaultThree": {
    "type": "object",
    "description": "故障状态3故障集合",
    "properties": {
      "cdMosHighTemperatureStatus": {
        "type": "Integer",
        "description": "充电MOS过温警告",
        "mock": {
          "mock": "@integer"
        }
      },
      "fdMosHighTemperatureStatus": {
        "type": "Integer",
        "description": "放电MOS过温警告",
        "mock": {
          "mock": "@integer"
        }
      },
      "cdMosSensorMalfunctionStatus": {
        "type": "Integer",
        "description": "充电MOS温度检测传感器故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "fdMosSensorMalfunctionStatus": {
        "type": "Integer",
        "description": "放电MOS温度检测传感器故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "cdMosAdhesiveMalfunctionStatus": {
        "type": "Integer",
        "description": "充电MOS粘连故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "fdMosAdhesiveMalfunctionStatus": {
        "type": "Integer",
        "description": "放电MOS粘连故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "cdMosOpenCircuitFaultStatus": {
        "type": "Integer",
        "description": "充电MOS断路故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "fdMosOpenCircuitFaultStatus": {
        "type": "Integer",
        "description": "放电MOS断路故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "afeFaultStatus": {
        "type": "Integer",
        "description": "AFE采集芯片故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "singleUnitCollectionDisconnectedStatus": {
        "type": "Integer",
        "description": "单体采集掉线",
        "mock": {
          "mock": "@integer"
        }
      },
      "individualTemperatureSensorMalfunctionStatus": {
        "type": "Integer",
        "description": "单体温度传感器故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "eepromFaultStatus": {
        "type": "Integer",
        "description": "EEPROM存储故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "rtcFaultStatus": {
        "type": "Integer",
        "description": "RTC时钟故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "preChargingFailedStatus": {
        "type": "Integer",
        "description": "预充失败",
        "mock": {
          "mock": "@integer"
        }
      },
      "vehicleCommunicationMalfunctionStatus": {
        "type": "Integer",
        "description": "整车通信故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "internalNetworkCommunicationModuleMalfunctionStatus": {
        "type": "Integer",
        "description": "内网通信模块故障",
        "mock": {
          "mock": "@integer"
        }
      }
    },
    "required": []
  },
  "faultStatusFour": {
    "type": "Integer",
    "description": "故障状态4",
    "mock": {
      "mock": "@integer"
    }
  },
  "daLiFaultFour": {
    "type": "object",
    "description": "故障状态4故障集合",
    "properties": {
      "currentModuleMalfunctionStatus": {
        "type": "Integer",
        "description": "电流模块故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "internalTotalPressureFaultStatus": {
        "type": "Integer",
        "description": "内总压检测模块故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "shortCircuitProtectionFaultStatus": {
        "type": "Integer",
        "description": "短路保护故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "lowVoltageProhibitedChargingFaultStatus": {
        "type": "Integer",
        "description": "低压禁止充电故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "gpsOrSoftSwitchDisconnectMOS": {
        "type": "Integer",
        "description": "GPS或软开关断开MOS",
        "mock": {
          "mock": "@integer"
        }
      },
      "chargingCabinetOffline": {
        "type": "Integer",
        "description": "充电柜离线",
        "mock": {
          "mock": "@integer"
        }
      },
      "thermalRunawayFault": {
        "type": "Integer",
        "description": "热失控故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "heatingMalfunction": {
        "type": "Integer",
        "description": "加热故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "balanceModuleCommunicationFailure": {
        "type": "Integer",
        "description": "均衡模块通讯故障",
        "mock": {
          "mock": "@integer"
        }
      },
      "equilibriumOpenConditionError": {
        "type": "Integer",
        "description": "均衡开启条件不满足",
        "mock": {
          "mock": "@integer"
        }
      },
      "abnormalVoltageCollection": {
        "type": "Integer",
        "description": "电压采集异常",
        "mock": {
          "mock": "@integer"
        }
      },
      "batteryFullyCharged": {
        "type": "Integer",
        "description": "电池充满",
        "mock": {
          "mock": "@integer"
        }
      }
    },
    "required": []
  },
  "remainingMileage": {
    "type": "Double",
    "description": "剩余里程",
    "mock": {
      "mock": "@float"
    }
  },
  "activeEquilibriumState": {
    "type": "Integer",
    "description": "主动均衡状态",
    "mock": {
      "mock": "@integer"
    }
  },
  "activeEquilibriumStateName": {
    "type": "String",
    "description": "主动均衡状态名称",
    "mock": {
      "mock": "@string"
    }
  },
  "equalizingCurrent": {
    "type": "Double",
    "description": "均衡电流",
    "mock": {
      "mock": "@float"
    }
  },
  "balancedPosition": {
    "type": "Integer",
    "description": "均衡位置",
    "mock": {
      "mock": "@integer"
    }
  },
  "mosTemperature": {
    "type": "Integer",
    "description": "MOS温度",
    "mock": {
      "mock": "@integer"
    }
  },
  "reserve_5": {
    "type": "Integer",
    "description": "预留5",
    "mock": {
      "mock": "@integer"
    }
  },
  "reserve_6": {
    "type": "Integer",
    "description": "预留6",
    "mock": {
      "mock": "@integer"
    }
  },
  "reserve_7": {
    "type": "Integer",
    "description": "预留7",
    "mock": {
      "mock": "@integer"
    }
  },
  "reserve_8": {
    "type": "Integer",
    "description": "预留8",
    "mock": {
      "mock": "@integer"
    }
  },
  "sn": {
    "type": "String",
    "description": "sn",
    "mock": {
      "mock": "@string"
    }
  },
  "antiTheftStatus": {
    "type": "Integer",
    "description": "防盗状态",
    "mock": {
      "mock": "@integer"
    }
  },
  "antiTheftStatusName": {
    "type": "String",
    "description": "防盗状态名称",
    "mock": {
      "mock": "@string"
    }
  },
  "heatingState": {
    "type": "Integer",
    "description": "加热状态",
    "mock": {
      "mock": "@integer"
    }
  },
  "heatingStateName": {
    "type": "String",
    "description": "加热状态名称",
    "mock": {
      "mock": "@string"
    }
  },
  "lastChargingTime": {
    "type": "String",
    "description": "最近一次充电时间",
    "mock": {
      "mock": "@string"
    }
  },
  "lastDischargeTime": {
    "type": "String",
    "description": "最近一次放电时间",
    "mock": {
      "mock": "@string"
    }
  },
  "ratedCapacity": {
    "type": "Double",
    "description": "额定容量",
    "mock": {
      "mock": "@float"
    }
  },
  "individualReferenceVoltage": {
    "type": "Integer",
    "description": "单体基准电压",
    "mock": {
      "mock": "@integer"
    }
  },
  "boardsNum": {
    "type": "Integer",
    "description": "采集板个数",
    "mock": {
      "mock": "@integer"
    }
  },
  "boardsNumOne": {
    "type": "Integer",
    "description": "采集板1单体个数",
    "mock": {
      "mock": "@integer"
    }
  },
  "boardsNumTwo": {
    "type": "Integer",
    "description": "采集板2单体个数",
    "mock": {
      "mock": "@integer"
    }
  },
  "boardsNumThree": {
    "type": "Integer",
    "description": "采集板3单体个数",
    "mock": {
      "mock": "@integer"
    }
  },
  "boardsTemperatureNumOne": {
    "type": "Integer",
    "description": "采集板1温度个数",
    "mock": {
      "mock": "@integer"
    }
  },
  "boardsTemperatureNumTwo": {
    "type": "Integer",
    "description": "采集板2温度个数",
    "mock": {
      "mock": "@integer"
    }
  },
  "boardsTemperatureNumThree": {
    "type": "Integer",
    "description": "采集板3温度个数",
    "mock": {
      "mock": "@integer"
    }
  },
  "batteryType": {
    "type": "Integer",
    "description": "电池类型",
    "mock": {
      "mock": "@integer"
    }
  },
  "batteryTypeName": {
    "type": "String",
    "description": "电池类型名称",
    "mock": {
      "mock": "@string"
    }
  },
  "waitTime": {
    "type": "Integer",
    "description": "休眠等待时间",
    "mock": {
      "mock": "@integer"
    }
  },
  "singleCellVoltageHighOneAlarm": {
    "type": "Integer",
    "description": "单体电压过高一级告警",
    "mock": {
      "mock": "@integer"
    }
  },
  "singleCellVoltageHighTwoAlarm": {
    "type": "Integer",
    "description": "单体电压过高二级告警",
    "mock": {
      "mock": "@integer"
    }
  },
  "singleCellVoltageLowOneAlarm": {
    "type": "Integer",
    "description": "单体电压过低一级告警",
    "mock": {
      "mock": "@integer"
    }
  },
  "singleCellVoltageLowTwoAlarm": {
    "type": "Integer",
    "description": "单体电压过低二级告警",
    "mock": {
      "mock": "@integer"
    }
  },
  "totalSingleCellVoltageHighOneAlarm": {
    "type": "Double",
    "description": "总压过高一级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "totalSingleCellVoltageHighTwoAlarm": {
    "type": "Double",
    "description": "总压过高二级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "totalSingleCellVoltageLowOneAlarm": {
    "type": "Double",
    "description": "总压过低一级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "totalSingleCellVoltageLowTwoAlarm": {
    "type": "Double",
    "description": "总压过低二级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "chargingCurrentHighOneAlarm": {
    "type": "Double",
    "description": "充电电流过高一级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "chargingCurrentHighTwoAlarm": {
    "type": "Double",
    "description": "充电电流过高二级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "fdCurrentHighOneAlarm": {
    "type": "Double",
    "description": "放电电流过高一级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "fdCurrentHighTwoAlarm": {
    "type": "Double",
    "description": "放电电流过高二级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "cdtemperatureHighOneAlarm": {
    "type": "Double",
    "description": "充电温度过高一级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "cdtemperatureHighTwoAlarm": {
    "type": "Double",
    "description": "充电温度过高二级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "cdtemperatureLowOneAlarm": {
    "type": "Double",
    "description": "充电温度过低一级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "cdtemperatureLowTwoAlarm": {
    "type": "Double",
    "description": "充电温度过低二级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "fdtemperatureHighOneAlarm": {
    "type": "Double",
    "description": "放电温度过高一级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "fdtemperatureHighTwoAlarm": {
    "type": "Double",
    "description": "放电温度过高二级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "fdtemperatureLowOneAlarm": {
    "type": "Double",
    "description": "放电温度过低一级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "fdtemperatureLowTwoAlarm": {
    "type": "Double",
    "description": "放电温度过低二级告警",
    "mock": {
      "mock": "@float"
    }
  },
  "differentialPressureHighOneAlarm": {
    "type": "Integer",
    "description": "压差过大一级告警值",
    "mock": {
      "mock": "@integer"
    }
  },
  "differentialPressureHighTwoAlarm": {
    "type": "Integer",
    "description": "压差过大二级告警值",
    "mock": {
      "mock": "@integer"
    }
  },
  "differentialTemperatureHighOneAlarm": {
    "type": "Integer",
    "description": "温差过大一级告警值",
    "mock": {
      "mock": "@integer"
    }
  },
  "differentialTemperatureHighTwoAlarm": {
    "type": "Integer",
    "description": "温差过大二级告警值",
    "mock": {
      "mock": "@integer"
    }
  },
  "balancedVoltage": {
    "type": "Integer",
    "description": "均衡开启电压",
    "mock": {
      "mock": "@integer"
    }
  },
  "balancedPressure": {
    "type": "Integer",
    "description": "均衡开启压差",
    "mock": {
      "mock": "@integer"
    }
  },
  "cdMosControl": {
    "type": "Integer",
    "description": "充电MOS管开关控制",
    "mock": {
      "mock": "@integer"
    }
  },
  "cdMosControlName": {
    "type": "String",
    "description": "充电MOS管开关控制名称",
    "mock": {
      "mock": "@string"
    }
  },
  "fdMosControl": {
    "type": "Integer",
    "description": "放电MOS管开关控制",
    "mock": {
      "mock": "@integer"
    }
  },
  "fdMosControlName": {
    "type": "String",
    "description": "放电MOS管开关控制",
    "mock": {
      "mock": "@string"
    }
  },
  "socSet": {
    "type": "Integer",
    "description": "SOC设置",
    "mock": {
      "mock": "@integer"
    }
  },
  "powerTubeTemperatureprotectionAlarm": {
    "type": "Integer",
    "description": "功率管温度保护告警",
    "mock": {
      "mock": "@integer"
    }
  },
  "softwareVersion": {
    "type": "String",
    "description": "软件版本号",
    "mock": {
      "mock": "@string"
    }
  },
  "hardwareVersion": {
    "type": "String",
    "description": "硬件版本号",
    "mock": {
      "mock": "@string"
    }
  },
  "code": {
    "type": "String",
    "description": "机器编码",
    "mock": {
      "mock": "@string"
    }
  },
  "systemRestart": {
    "type": "Integer",
    "description": "系统重启",
    "mock": {
      "mock": "@integer"
    }
  },
  "systemClose": {
    "type": "Integer",
    "description": "关闭系统",
    "mock": {
      "mock": "@integer"
    }
  },
  "shutDownSystem": {
    "type": "Integer",
    "description": "电流归零",
    "mock": {
      "mock": "@integer"
    }
  },
  "restoreFactorySettings": {
    "type": "Integer",
    "description": "恢复出厂设置",
    "mock": {
      "mock": "@integer"
    }
  },
  "paramSetPassword": {
    "type": "String",
    "description": "参数设置密码",
    "mock": {
      "mock": "@string"
    }
  },
  "dateOfManufacture": {
    "type": "String",
    "description": "生产日期",
    "mock": {
      "mock": "@string"
    }
  },
  "batteryStringsNum": {
    "type": "Integer",
    "description": "电池串数",
    "mock": {
      "mock": "@integer"
    }
  },
  "activeBalanceSwitch": {
    "type": "Integer",
    "description": "主动均衡开关",
    "mock": {
      "mock": "@integer"
    }
  },
  "activeBalanceSwitchName": {
    "type": "String",
    "description": "主动均衡开关名称",
    "mock": {
      "mock": "@string"
    }
  },
  "activeCurrentBalancing": {
    "type": "Double",
    "description": "主动均衡电流",
    "mock": {
      "mock": "@float"
    }
  },
  "communication": {
    "type": "Integer",
    "description": "通信方式",
    "mock": {
      "mock": "@integer"
    }
  },
  "communicationName": {
    "type": "String",
    "description": "通信方式名称",
    "mock": {
      "mock": "@string"
    }
  },
  "inverterManufacturer": {
    "type": "Integer",
    "description": "逆变器制造商",
    "mock": {
      "mock": "@integer"
    }
  },
  "inverterManufacturerName": {
    "type": "String",
    "description": "逆变器制造商",
    "mock": {
      "mock": "@string"
    }
  },
  "rtc": {
    "type": "String",
    "description": "rtc",
    "mock": {
      "mock": "@string"
    }
  },
  "forceStartSwitch": {
    "type": "Integer",
    "description": "强制启动开关",
    "mock": {
      "mock": "@integer"
    }
  },
  "heatingSwitch": {
    "type": "Integer",
    "description": "加热开关",
    "mock": {
      "mock": "@integer"
    }
  },
  "heatingSwitchName": {
    "type": "String",
    "description": "加热开关名称",
    "mock": {
      "mock": "@string"
    }
  },
  "socHighAlarmValue": {
    "type": "Double",
    "description": "SOC过高告警值",
    "mock": {
      "mock": "@float"
    }
  },
  "socHighAlarmRecoveryValue": {
    "type": "Double",
    "description": "SOC过高告警恢复值",
    "mock": {
      "mock": "@float"
    }
  },
  "socLowAlarmValue": {
    "type": "Double",
    "description": "SOC过低告警值",
    "mock": {
      "mock": "@float"
    }
  },
  "socLowAlarmRecoveryValue": {
    "type": "Double",
    "description": "SOC过低告警恢复值",
    "mock": {
      "mock": "@float"
    }
  },
  "lightAlarmOrBuzzerAlarm": {
    "type": "Integer",
    "description": "灯光告警或蜂鸣器告警",
    "mock": {
      "mock": "@integer"
    }
  },
  "lightAlarmOrBuzzerAlarmName": {
    "type": "String",
    "description": "灯光告警或蜂鸣器告警名称",
    "mock": {
      "mock": "@string"
    }
  },
  "voltageCalibration": {
    "type": "Double",
    "description": "电压校准",
    "mock": {
      "mock": "@float"
    }
  },
  "xacceleration": {
    "type": "Integer",
    "description": "x轴加速度",
    "mock": {
      "mock": "@integer"
    }
  },
  "yacceleration": {
    "type": "Integer",
    "description": "y轴加速度",
    "mock": {
      "mock": "@integer"
    }
  },
  "zacceleration": {
    "type": "Integer",
    "description": "z轴加速度",
    "mock": {
      "mock": "@integer"
    }
  },
  "unlockStateControl": {
    "type": "Integer",
    "description": "解锁状态控制",
    "mock": {
      "mock": "@integer"
    }
  },
  "unlockStateControlName": {
    "type": "String",
    "description": "解锁状态控制名称",
    "mock": {
      "mock": "@string"
    }
  },
  "balancedCutOffVoltage": {
    "type": "Integer",
    "description": "均衡截止电压",
    "mock": {
      "mock": "@integer"
    }
  },
  "heatingActivationTemperature": {
    "type": "Integer",
    "description": "加热开启温度",
    "mock": {
      "mock": "@integer"
    }
  },
  "keyLogic": {
    "type": "Integer",
    "description": "钥匙逻辑",
    "mock": {
      "mock": "@integer"
    }
  },
  "keyLogicName": {
    "type": "String",
    "description": "钥匙逻辑名称",
    "mock": {
      "mock": "@string"
    }
  },
  "balancedTreasure": {
    "type": "Integer",
    "description": "均衡宝印规版本启用开关",
    "mock": {
      "mock": "@integer"
    }
  },
  "balancedTreasureName": {
    "type": "String",
    "description": "均衡宝名称印规版本启用开关",
    "mock": {
      "mock": "@string"
    }
  }
}
